<template>
  <v-list dense nav class="px-0">
    <v-list-group color="darkGray" v-if="itens_cadastro.length > 0">
      <template v-slot:activator>
        <v-list-item>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on" class="ml-1"
                  >mdi-playlist-edit</v-icon
                >
              </v-list-item-icon>
            </template>
            <span>Cadastros</span>
          </v-tooltip>
          <v-list-item-title class="ml-n4">Cadastro</v-list-item-title>
        </v-list-item>
      </template>
      <v-divider class="mb-1" />
      <div class="ml-4">
        <v-list-item
          v-for="(cadastro, i) in itens_cadastro"
          :key="`cadastro_callcenter_${i}`"
          :href="cadastro.href"
          target="_blank"
          @click="redirect(cadastro.way, $event)"
          :class="isActive(cadastro.way)"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                  cadastro.icon
                }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ cadastro.message }}</span>
          </v-tooltip>
          <v-list-item-title class="ml-n6">{{
            cadastro.title
          }}</v-list-item-title>
        </v-list-item>
      </div>
      <v-divider class="my-1" />
    </v-list-group>

    <v-list-group color="darkGray" v-if="itens_relatorios.length > 0">
      <template v-slot:activator>
        <v-list-item>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on"
                  >mdi-chart-box</v-icon
                >
              </v-list-item-icon>
            </template>
            <span>Relatórios</span>
          </v-tooltip>
          <v-list-item-title class="ml-n4">Relatórios</v-list-item-title>
        </v-list-item>
      </template>
      <v-divider class="mb-1" />
      <div class="ml-4">
        <v-list-item
          v-for="(relatorio, i) in itens_relatorios"
          :key="`relatorio_callcenter_${i}`"
          :href="relatorio.href"
          target="_blank"
          @click="redirect(relatorio.way, $event)"
          :class="isActive(relatorio.way)"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                  relatorio.icon
                }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ relatorio.message }}</span>
          </v-tooltip>
          <v-list-item-title class="ml-n6">{{
            relatorio.title
          }}</v-list-item-title>
        </v-list-item>
      </div>
      <v-divider class="my-1" />
    </v-list-group>

    <!-- <v-list-group color="darkGray" v-if="itens_monitorOperador.length > 0">
      <template v-slot:activator>
        <v-list-item>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on"
                  >mdi-card-text-outline</v-icon
                >
              </v-list-item-icon>
            </template>
            <span>Monitor de Operadores</span>
          </v-tooltip>
          <v-list-item-title class="ml-n4 mr-n4">Monitor de Operadores</v-list-item-title>
        </v-list-item>
      </template>
      <v-divider class="mb-1" />
      <div class="ml-4">
        <v-list-item
          v-for="(monitorOperador, i) in itens_monitorOperador"
          :key="`monitorOperador_callcenter_${i}`"
          :href="monitorOperador.href"
          target="_blank"
          @click="redirect(monitorOperador.way, $event)"
          :class="isActive(monitorOperador.way)"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                  monitorOperador.icon
                }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ monitorOperador.message }}</span>
          </v-tooltip>
          <v-list-item-title class="ml-n6">{{
            monitorOperador.title
          }}</v-list-item-title>
        </v-list-item>
      </div>
      <v-divider class="my-1" />
    </v-list-group> -->

    <div class="px-2">
      <v-list-item
        v-for="item in itens_avulsos"
        :key="item.title"
        :href="item.href"
        target="_blank"
        @click="redirect(item.way, $event)"
        :class="isActive(item.way)"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-icon>
              <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                item.icon
              }}</v-icon>
            </v-list-item-icon>
          </template>
          <span>{{ item.message }}</span>
        </v-tooltip>
        <v-list-item-title class="ml-n4">{{ item.title }}</v-list-item-title>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";
import { goToSelectedPath } from "@/utils/commomMethods/goToSelectedPath";

import {
  permissionsCadastroOperador,
  permissionsCadastroPausa,
  permissionsCadastroFila,
  permissionsCadastroDepartamento,
  permissionsRelatorioOperador,
  permissionsRelatorioFila,
  permissionsRelatorioDisponibilidade,
  permissionsManutencaoOperadores,
  permissionsMonitorFilas,
  permissionsMonitorOperador,
  permissionsConfigCallCenter,
} from "../utils/permissionsCallCenter";

export default {
  name: "ListNavigationDrawerCallcenter",
  props: {
    drawer: Boolean,
  },
  data: () => ({
    rotaSelecionada: "",
    itens_cadastro: [],
    itens_relatorios: [],
    // itens_monitorOperador: [],
    itens_avulsos: [],
    cadastroOperador: false, 
    cadastroPausa: false,
    cadastroFila: false,
    cadastroDepartamento: false,
    relatorioOperador: false,
    relatorioFila: false,
    relatorioDisponibilidade: false,
    manutencaoOperadores: false,
    monitorFilas: false,
    monitorOperador: false,
    configuracaoCallCenter: false
  }),

  async created() {
    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    arrayPermissions.sort();

    arrayPermissions.forEach((permissionLocalStorage) => {
      if (
        permissionsCadastroDepartamento.includes(permissionLocalStorage) &&
        !this.cadastroDepartamento
      ) {
        this.cadastroDepartamento = true;
        this.itens_cadastro.push({
          title: "Departamento",
          way: "Departamento",
          icon: "mdi-account-supervisor-circle-outline",
          message: "Cadastro Departamento",
          href: "/central-de-atendimento/cadastro/departamento",
        });
      }
      if (
        permissionsCadastroFila.includes(permissionLocalStorage) &&
        !this.cadastroFila
      ) {
        this.cadastroFila = true;
        this.itens_cadastro.push({
          title: "Fila",
          way: "Fila",
          icon: "mdi-menu",
          message: "Cadastro Fila",
          href: "/central-de-atendimento/cadastro/fila",
        });
      }
      if (
        permissionsCadastroOperador.includes(permissionLocalStorage) &&
        !this.cadastroOperador
      ) {
        this.cadastroOperador = true;
        this.itens_cadastro.push({
          title: "Operador",
          way: "Operador",
          icon: "mdi-account-circle-outline",
          message: "Cadastro de Operador",
          href: "/central-de-atendimento/cadastro/operador",
        });
      }
      if (
        permissionsCadastroPausa.includes(permissionLocalStorage) &&
        !this.cadastroPausa
      ) {
        this.cadastroPausa = true;
        this.itens_cadastro.push({
          title: "Pausa",
          way: "Pausa",
          icon: "mdi-pause-circle-outline",
          message: "Cadastro de Pausa",
          href: "/central-de-atendimento/cadastro/pausa",
        });
      }      
      if (
        permissionsRelatorioDisponibilidade.includes(permissionLocalStorage) &&
        !this.relatorioDisponibilidade
      ) {
        this.relatorioDisponibilidade = true;
        this.itens_relatorios.push({
          title: "Disponibilidade",
          way: "RelatorioDisponibilidade",
          icon: "mdi-check-circle-outline",
          message: "Disponibilidade",
          href: "/central-de-atendimento/relatorioscallcenter/disponibilidade",
        });
      }
      if (
        permissionsRelatorioFila.includes(permissionLocalStorage) &&
        !this.relatorioFila
      ) {
        this.relatorioFila = true;
        this.itens_relatorios.push({
          title: "Filas",
          icon: "mdi-chart-donut",
          way: "RelatorioFilas",
          message: "Fila",
          href: "/central-de-atendimento/relatorioscallcenter/filas",
        });
      }
      if (
        permissionsRelatorioOperador.includes(permissionLocalStorage) &&
        !this.relatorioOperador
      ) {
        this.relatorioOperador = true;
        this.itens_relatorios.push({
          title: "Operador",
          way: "RelatorioOperadores",
          icon: "mdi-chart-line",
          message: "Operador",
          href: "/central-de-atendimento/relatorioscallcenter/operadores",
        });
      }
      if (
        permissionsConfigCallCenter.includes(permissionLocalStorage) &&
        !this.configuracaoCallCenter
      ) {
        this.configuracaoCallCenter = true;
        this.itens_avulsos.push({
          title: "Configuração",
          // icon: "mdi-cog-box",
          icon: "mdi-cog",
          way: "ConfiguracaoCallCenter",
          message: "Configuração do Call Center",
          href: "/central-de-atendimento/configuracao-call-center",
        });
      }
      if (
        permissionsManutencaoOperadores.includes(permissionLocalStorage) &&
        !this.manutencaoOperadores
      ) {
        this.manutencaoOperadores = true;
        this.itens_avulsos.push({
          title: "Manutenção de Operadores",
          icon: "mdi-account-remove",
          way: "GerenciaOperadores",
          message: "Manutenção de operadores",
          href: "/central-de-atendimento/gerenciamento/operadores",
        });
      }
      if (
        permissionsMonitorFilas.includes(permissionLocalStorage) &&
        !this.monitorFilas
      ) {
        this.monitorFilas = true;
        this.itens_avulsos.push({
          title: "Monitor de Filas",
          icon: "mdi-desktop-mac",
          way: "onlyMonitorCallCenter",
          message: "Monitor CallCenter",
          href: "/monitor",
        });
      }
      if (
        permissionsMonitorOperador.includes(permissionLocalStorage) &&
        !this.monitorOperador
      ) {
        this.monitorOperador = true;
        this.itens_avulsos.push({
          title: "Monitor de Operadores",
          icon: "mdi-card-account-phone-outline",
          way: "onlyMonitorOperador",
          message: "Monitor de Operadores",
          href: "/monitor-operador",
        });
      }
    });
  },

  methods: {
    ...goToSelectedPath,
    ...obtainUserPermissions,

    isActive(rota) {
      if (rota == this.$route.name) {
        this.rotaSelecionada = rota
        return "indigo lighten-5";
      } else if (rota == this.rotaSelecionada) {
        return "indigo lighten-5";
      }
    },
  },
};
</script>
